import { SmartLink, shadowSmall, SizableText, XStack, YStack, XStackProps } from '@my/ui'
import { SolitoImage } from 'solito/image'

export interface BrandTabItemProps {
  id: string
  name: string
  description?: string
  logo: {
    url: string
    alt: string
  }
  slug: string
  wrapperProps?: XStackProps
  imagePriority?: boolean
}

export const BrandTabItem = (props: BrandTabItemProps) => {
  return (
    <SmartLink
      Component={XStack}
      href={`/discounts/${props.slug}`}
      ai="center"
      bc="$white"
      gap="$3"
      br="$3"
      p={8}
      hoverStyle={{
        opacity: 0.8,
      }}
      pressStyle={{
        opacity: 0.8,
      }}
      $gtXs={{
        fd: 'column',
        py: '$3.5',
        flex: 1,
      }}
      {...shadowSmall}
      {...props.wrapperProps}
    >
      {props.logo?.url && (
        <YStack
          w={44}
          h={44}
          bc="$white"
          br="$3"
          $gtXs={{
            w: 88,
            h: 88,
            bw: '$2',
            boc: '$white',
            ...shadowSmall,
          }}
        >
          <SolitoImage
            fill
            src={props.logo.url}
            alt={props.logo.alt}
            contentFit="contain"
            sizes="(max-width: 567px) 44px, 88px"
            priority={props.imagePriority}
          />
        </YStack>
      )}

      <YStack gap="$1" fs={1}>
        <SizableText numberOfLines={2} size="$5" fow="600" $gtXs={{ ta: 'center' }}>
          {props.name}
        </SizableText>

        {props.description && (
          <SizableText
            numberOfLines={2}
            textAlign="center"
            color="$overlay11"
            size="$3"
            fow="500"
            $xs={{
              display: 'none',
            }}
          >
            {props.description}
          </SizableText>
        )}
      </YStack>
    </SmartLink>
  )
}
